import React from 'react';
import styled from 'styled-components';
import {colours} from '../Styles';

function PackagePriceCard(props) {
    const {transpWhite, accent, light} = colours;
    const PackagePriceCard = styled.div`
        margin: 10px;
        height: fit-content;
        width: 500px;
        border-radius: 10px;
        background: ${transpWhite};
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        .wrapper {
            display: flex;
        }
        .package-img {
            width: 60%;
            height: 100px;
            object-fit: cover;
            align-self: flex-start;
        }
        .name-price {
            width: 40%;
            height: 100px;
            font-family: play, sans-serif;
            display: flex;
            flex-direction: column;
            .name, .price {
                height: 50px;
                font-size: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                span {
                    font-size: 12px;
                    margin-top: 5px;
                    color: ${accent};
                }
            }
            .name {
                color: ${transpWhite};
            }
        }

        .option-list {
            list-style: none;
            width: 95%;
            margin-top: 10px;
            margin-bottom: 10px;
            li {
                padding: 5px 10px;
                :nth-child(2n) {
                    background: ${light}
                }
            }
        }

        p {
            font-size: 14px;
        }

        @media only screen and (max-width: 600px) {
            width: 90%;
        }

        #Gold {
            background-image: linear-gradient(315deg, #d99058 0%, #f8de7e 74%);
        }
    
        #Platinum {
            background-image: linear-gradient(315deg, #000000 0%, #414141 74%);
        }
    `;

    const optionList = props.options.map((item) => <li>{item}</li>)

    return (
    <PackagePriceCard>
        <div className="wrapper">
            <img className="package-img" src={props.imgsrc} alt={props.imgalt}/>
            <div className="name-price">
                <div className="name" id={props.name}>{props.name}</div>
                <div className="price">${props.price}<span>{props.alternatePrice}</span></div>
            </div>
        </div>
        <ul className="option-list">
            {optionList}
        </ul>
        <p>add $25 for SUV's / Minivans / Trucks</p>
    </PackagePriceCard>)
}

export default PackagePriceCard;